<template>
<v-container>
  <v-form v-model="valid" ref="form">
    <v-flex xs6 offset-xs3>
      <v-flex xs6 offset-xs3 mb-3>
        <label class="headline">Byt l�senord</label>
      </v-flex>
      <v-layout row>
        <v-text-field required v-model="password1" id="password" name="password" label="L�senord" type="password" ></v-text-field>
      </v-layout>
      <v-layout row>
        <v-text-field required v-model="password2" id="password" name="password" label="Ange l�senordet igen" type="password"></v-text-field>
      </v-layout>
      <v-layout row>
        <v-flex xs6 offset-xs6>
          <v-btn color="primary" block @click="changepassword()">Spara nytt l�senord</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-form>
     <v-snackbar error color="error" v-model="showsnackbarerror">
      {{ snackbartexterror }}
      <v-btn dark flat @click="showsnackbarerror = false">
        St�ng
      </v-btn>
    </v-snackbar>
    <v-snackbar success color="success" v-model="showsnackbar" :timeout="timeout">
      {{ snackbartext }}
      <v-btn
        dark
        flat
        @click="showsnackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
</v-container>
</template>

<script>
import {HTTP} from '@/backend/client'

export default {
  name: 'Login',
  data () {
    return {
      valid: true,
      loading: false,
      password1: null,
      password2: null,
      showsnackbar: false,
      snackbartext: null,
      timeout: 2000,
      showsnackbarerror: false,
      snackbartexterror: null,
      guid: this.$route.query['guid']
    }
  },
  created () {
    HTTP.get('/account/validateguid/' + this.guid)
      .catch(e => {
        this.snackbartexterror = 'Fel vid validering'
        this.showsnackbarerror = true
      })
  },
  methods: {
    changepassword () {
      if (this.$refs.form.validate() && this.password1 !== null && this.password1 === this.password2) {
        this.loading = true
        HTTP.post('/account/changepassword', {password: this.password1, guid: this.guid})
          .then(response => {
            this.snackbartext = 'Nytt l�senord sparat. Prova att logga in igen med det nya l�senordet'
            this.showsnackbar = true
          })
          .catch(e => {
            this.snackbartexterror = e.message
            this.showsnackbarerror = true
          })
      } else {
        this.snackbartexterror = 'Ange samma l�senord i b�gge f�lten'
        this.showsnackbarerror = true
      }
    }
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue